export default __webpack_public_path__ + "static/media/submissions.e0ade6fa.csv";